import { Component, forwardRef, Renderer2, ViewChild, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PermissionService } from '../../../service/permission/permission.service';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { Permission } from '../../../class/permission';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MultiSelectPermissionComponent),
  multi: true,
};

@Component({
  selector: 'app-multiselect-permissions',
  templateUrl: './multiselect-permissions.component.html',
  styleUrls: ['./multiselect-permissions.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class MultiSelectPermissionComponent implements ControlValueAccessor {
    @Input() permissionsId: Permission[];
    @ViewChild('input') textarea;

    public permissions: AbstractControl;
    public permissionsSelected: SelectItem[];
    public permissionOptions: SelectItem[];

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    constructor(
        private renderer: Renderer2,
        public permissionService: PermissionService
    ) {
        this.page = 1;
        this.per_page = 1000;
        this.query = undefined;
        this.filters = [];
        this.filters.push({key: 'activated-lk', value: '1'});
        this.getPermissions(this.query, this.filters);
    }

    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean ) {
        const div = this.textarea.nativeElement;
        const action = isDisabled ? 'addClass' : 'removeClass';
        this.renderer[action](div, 'disabled');
    }

    public change($event) {
        this.onChange($event.value);
        this.onTouched($event.value);
    }

    getPermissions(query?: string, filters?: any[]) {
        this.permissionService.getPermission(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                const permissions = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }

                this.permissionOptions = [];
                permissions.forEach(element => {
                    this.permissionOptions.push({'value': element.id, 'label': element.name});
                });

                if (this.permissionsId) {
                    this.permissionsSelected = [];
                    this.permissionsId.forEach(element => {
                        this.permissionsSelected.push({'value': element.id, 'label': element.name});
                    });
                }
            },
            error => {
                this.permissionOptions = [];
                this.permissionOptions.push({value: '', label: 'Error'});
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/permissions/multiselect-permissions/multiselect-permissions.component.ts